import { render } from "./DocumentTemplateEditor.vue?vue&type=template&id=e5fb79d8&scoped=true&ts=true"
import script from "./DocumentTemplateEditor.vue?vue&type=script&lang=ts"
export * from "./DocumentTemplateEditor.vue?vue&type=script&lang=ts"

import "./DocumentTemplateEditor.vue?vue&type=style&index=0&id=e5fb79d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5fb79d8"]])

export default __exports__